import { Injectable } from '@angular/core';
import { GenericUtilityService } from '../generic/generic-utility.service';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  constructor(private genericService: GenericUtilityService) { }

  SubmitAfterVisitSurvey(payload: any): any {
    return this.genericService.ApiPostMethodTalkphr('TalkCheckInPhaseThree', 'SavePatientFeedback', payload);
  }
}
